import slice from './slice.tenant';
import * as tenantTypes from './types.tenant';

export const { reducer: tenantState, actions: tenantActions } = slice;
export { tenantTypes };
export { default as tenantSaga } from './saga.tenant';
export { default as tenantSelector } from './selector.tenant';
export default slice;
